// extracted by mini-css-extract-plugin
export const postCounter = "counterNumberStyles-module--postCounter--1burk";
export const likeButtonContainer = "counterNumberStyles-module--likeButtonContainer--ztvsz";
export const likeButton = "counterNumberStyles-module--likeButton--uns_x";
export const counter = "counterNumberStyles-module--counter--3ONuY";